export const langText: any = {
    us: {
        member_only: 'Member-only',
        member_only_none: '(Non-member price)',
        link_more: 'Learn More',
        link_buy: 'Buy Now',
        sold_out: 'Sold Out',
    },
};
